import React, { useEffect, useState } from 'react';
import GlobalWrapper from '../../../../components/Wrapper/GlobalWrapper';
import dayjs from 'dayjs';
import FromAndToDatePicker from '../../../../components/mui/FromAndToDatePicker';
import GlobalSelectFieldWithoutFormik from '../../../../components/mui/GlobalSelectFieldWithoutFormik';
import { Stack } from '@mui/material';
import GlobalTable from '../../../../components/CustomTableWithPagination/GlobalTable';
import { StudentDetailsTableHeader, studentStatus } from './utils/studentDetailPageHelper';
import { useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getStudentDetails } from '../../../../redux/features/dashboardSlice';
import { COMPANY } from './utils/employeeDetailsPageHelper';

export default function StudentDetails() {
  const [searchParams, setSearchParams] = useSearchParams();

  const queryFromDate = searchParams.get('fromDate');
  const queryToDate = searchParams.get('toDate');
  const queryName = searchParams.get('name');

  const [filters, setFilters] = useState({
    fromDate: dayjs().startOf('month'),
    toDate: dayjs().endOf('month'),
    status: { id: -1, value: '' },
    company: { id: -1, value: '' },
  });
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    sort: { field: '', direction: '' },
    frozenColumns: [],
    hiddenColumns: [],
  });

  const dispatch = useDispatch();

  const studentDetailsLoading = useSelector((state) => state.dashboard.studentsDetails.loading);
  const studentDetailsData = useSelector((state) => state.dashboard.studentsDetails.data);
  const studentDetailsMeta = useSelector((state) => state.dashboard.studentsDetails.meta);

  const filterHelper = (value, key) => {
    if (!value || !key) return;
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  useEffect(() => {
    const params = {
      search: tableState?.search,
      startDate: filters.fromDate,
      endDate: filters.toDate,
      page: tableState.page,
      limit: tableState.pageSize,
      status: filters?.status?.id === -1 ? '' : filters.status?.id,
      sortBy: tableState.sort.field,
      sortDirection: tableState.sort.direction,
      dept: filters?.company?.id === -1 ? 'all' : filters?.company?.id,
    };
    dispatch(getStudentDetails(params)).then((res) => console.log({ res }));
  }, [filters, tableState.search, tableState.page, tableState.pageSize, dispatch, tableState.sort]);

  useEffect(() => {
    if (queryName === 'Total Students') {
      filterHelper({ id: -1, value: '' }, 'status');
    } else if (queryName === 'Active Students') {
      filterHelper({ id: 'active', value: '' }, 'status');
    }
    filterHelper(dayjs(queryFromDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'fromDate');
    filterHelper(dayjs(queryToDate, 'YYYY-MM-DD').format('YYYY-MM-DD'), 'toDate');
  }, [queryName, queryFromDate, queryToDate]);

  return (
    <GlobalWrapper title={'Student Details'}>
      <Stack direction={{ xs: 'column', sm: 'row' }} gap={1} mb={1}>
        <FromAndToDatePicker
          fromDate={filters.fromDate}
          toDate={filters.toDate}
          setFromDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'fromDate')}
          setToDate={(v) => filterHelper(dayjs(v).format('YYYY-MM-DD'), 'toDate')}
          fullWidth
        />
        <GlobalSelectFieldWithoutFormik
          sx={{ width: { xs: '100%', sm: 200 } }}
          keys={{ itemId: 'id', itemValue: 'name' }}
          label={'Status'}
          data={studentStatus}
          setDirectChange={(v) => filterHelper(v, 'status')}
          selectedDetails={filters['status']}
        />
        <GlobalSelectFieldWithoutFormik
          sx={{ width: { xs: '100%', sm: 200 } }}
          keys={{
            itemId: 'id',
            itemValue: 'name',
          }}
          label={'Company'}
          data={COMPANY}
          setDirectChange={(v) => filterHelper(v, 'company')}
          selectedDetails={filters['company']}
        />
      </Stack>
      <GlobalTable
        rowUniqueId="admn_no"
        headers={StudentDetailsTableHeader}
        rows={studentDetailsData}
        loading={studentDetailsLoading}
        tableState={tableState}
        setTableState={setTableState}
        meta={studentDetailsMeta}
      />
    </GlobalWrapper>
  );
}
